import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Paging } from '@cpd-app/core-module/models';

@Directive({
  selector: '[cpdLazyLoadingList]'
})
export class LazyLoadingListDirective implements OnInit, OnDestroy {
  @Input() public count = Infinity;
  @Input() public limit = 10;
  @Input() public offset = 0;
  @Input() public disabled = true;
  @Input() public sensitivity = 200;

  @Output() public next = new EventEmitter<Paging>();

  private scrollSub = new Subscription();

  constructor(private elementRef: ElementRef<HTMLDivElement>) {}

  public ngOnInit() {
    const srollDetectionElement = this.elementRef.nativeElement;
    const srollElement =
      srollDetectionElement === (window as any)
        ? document.querySelector('html')
        : srollDetectionElement;

    this.scrollSub = fromEvent(srollDetectionElement, 'wheel')
      .pipe(
        tap(() => {
          const { scrollHeight, scrollTop, offsetHeight } = srollElement;
          const scrollLeft = scrollHeight - scrollTop - offsetHeight;
          const canLoadMoreItem =
            this.count && this.count > this.offset + this.limit;

          if (
            scrollLeft <= this.sensitivity &&
            canLoadMoreItem &&
            !this.disabled
          ) {
            this.loadNext();
          }
        })
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.scrollSub.unsubscribe();
  }

  public reset(): void {
    this.offset = 0;
  }

  private loadNext(): void {
    this.offset += this.limit;

    this.next.emit({
      limit: this.limit,
      offset: this.offset
    });
  }
}
